var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState } from 'react';
import Hero from '../../../components/Hero';
import Paragraph from '../../../components/Typography/Paragraph';
import TextInput from '../../../components/Fields/TextInput';
import Button from '../../../components/Button';
import { RoutePaths } from '../../../config/routes';
import { ArrowRight } from 'react-feather';
import ModalBasic from '../../../components/Modal/Basic';
import Heading from '../../../components/Typography/Heading';
import { useValidation, ValidationString } from '../../../hooks/useValidation';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import axiosInstance from '../../../config/axios';
import { api } from '../../../config/api';
import { toast } from 'react-toastify';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Fields } from '../../../utils/Fields';
import Seo from '../../../components/Seo';
import { useUser } from '../../../hooks/useUser';
import { useSignOut } from 'react-auth-kit';
var PasswordReset = function () {
    var navigate = useNavigate();
    var signOut = useSignOut();
    var removeUserStorage = useUser().removeUserStorage;
    var _a = useSearchParams(), searchParams = _a[0], setSearchParams = _a[1];
    var _b = useValidation(), textRequired = _b.textRequired, passwordRequired = _b.passwordRequired, passwordConfirmation = _b.passwordConfirmation, passwordInstructions = _b.passwordInstructions;
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var _d = useState(false), modal = _d[0], setModal = _d[1];
    var schema = yup.object().shape({
        new_password: passwordRequired,
        new_password_confirmation: passwordConfirmation('new_password'),
        key: textRequired,
        login: textRequired,
    });
    var _e = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            key: searchParams.get('key') || '',
            login: searchParams.get('login') || '',
        },
    }), handleSubmit = _e.handleSubmit, control = _e.control, setError = _e.setError;
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, axiosInstance.post(api.password.reset, data)];
                case 2:
                    response = _a.sent();
                    removeUserStorage();
                    signOut();
                    setModal(true);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    if (error_1.response.status === 422) {
                        error_1.response.data.errors.forEach(function (error) {
                            setError(Object.keys(error)[0], { message: Object.values(error)[0] });
                        });
                    }
                    else {
                        toast.error(ValidationString.GLOBAL);
                    }
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (<>
      <Seo title="Réinitialiser votre mot de passe"/>
      <Hero title="Nouveau mot de passe" headline="Réinitialiser votre mot de passe"/>
      <div className="container">
        <div className="p-default grid lg:grid-cols-12">
          <div className="lg:col-span-6 lg:col-start-4">
            <Paragraph center>{passwordInstructions}</Paragraph>
            <form onSubmit={handleSubmit(onSubmit)} className="mt-8">
              <div className="flex flex-col gap-6">
                <TextInput name="new_password" control={control} label="Nouveau mot de passe" type={Fields.PASSWORD} required/>
                <TextInput name="new_password_confirmation" control={control} label="Confirmer le nouveau mot de passe" type={Fields.PASSWORD} required/>
              </div>
              <div className="flex flex-col gap-4">
                <Button submit className="mt-6" loading={loading}>
                  Réinitialiser mon mot de passe
                </Button>
                <Button onClick={function () { return navigate(RoutePaths.SIGN_IN); }} type="inline" icon={ArrowRight} side="start" alert="danger">
                  Retour à la connexion
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <ModalBasic handleClose={function () { return setModal(false); }} open={modal}>
        <div className="flex flex-col items-center gap-10">
          <Heading level={2} type="h5" className="text-center">
            Votre mot de passe a été réinitialisé
          </Heading>
          <Paragraph className="text-center">
            Cliquez sur le bouton ci-dessous pour vous connecter à votre compte
          </Paragraph>
          <Button onClick={function () { return navigate(RoutePaths.SIGN_IN); }}>Se connecter</Button>
        </div>
      </ModalBasic>
    </>);
};
export default PasswordReset;
